// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryEvidenceEntity from './entities/inquiry-evidence.json';
import inquiryEvidenceMenu from '../pages/inquiry-evidence/menu.json';
import inquiryEvidenceFullForm from '../pages/inquiry-evidence/forms/full.json';
import inquiryEvidenceContextForm from '../pages/inquiry-evidence/forms/context.json';
import inquiryEvidenceMiniForm from '../pages/inquiry-evidence/forms/mini.json';
import inquiryEvidenceLookupForm from '../pages/inquiry-evidence/forms/lookup.json';
import inquiryEvidenceTableView from '../pages/inquiry-evidence/views/table.json';
import inquiryEvidenceCardsView from '../pages/inquiry-evidence/views/cards.json';
import inquiryEvidenceCalendarView from '../pages/inquiry-evidence/views/calendar.json';
import inquiryEvidenceDashboardView from '../pages/inquiry-evidence/views/dashboard.json';

/** Тип запису «Отримані матеріали» зі сторінками пакета: меню, форми та подання з pages/inquiry-evidence/. */
export const inquiryEvidenceDefinition: IRecordTypeDefinition = {
  ...inquiryEvidenceEntity,
  views: assembleViewSet({
      table: inquiryEvidenceTableView,
      cards: inquiryEvidenceCardsView,
      calendar: inquiryEvidenceCalendarView,
      dashboard: inquiryEvidenceDashboardView,
  }),
  form: inquiryEvidenceFullForm,
  forms: { full: inquiryEvidenceFullForm, context: inquiryEvidenceContextForm, mini: inquiryEvidenceMiniForm, lookup: inquiryEvidenceLookupForm },
  menu: inquiryEvidenceMenu,
} as IRecordTypeDefinition;
